"use client";

import { useCallback, useLayoutEffect, useState } from "react";

import { ThemeToggleIos } from "@/components/ThemeToggleIos";
import { applyDocumentThemePreference, THEME_STORAGE_KEY } from "@/lib/documentTheme";

/** Same control + storage as the dashboard (`expirydesk-ui-theme`). */
export function BlogThemeToggle() {
  const [isDark, setIsDark] = useState(false);

  useLayoutEffect(() => {
    const read = () => setIsDark(document.documentElement.dataset.edTheme === "dark");
    read();
    const onStorage = (e: StorageEvent) => {
      if (e.key === THEME_STORAGE_KEY || e.key === null) read();
    };
    const onTheme = () => read();
    window.addEventListener("storage", onStorage);
    window.addEventListener("expirydesk-theme-change", onTheme);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("expirydesk-theme-change", onTheme);
    };
  }, []);

  const toggle = useCallback(() => {
    applyDocumentThemePreference(document.documentElement.dataset.edTheme !== "dark");
  }, []);

  return <ThemeToggleIos isDarkMode={isDark} onToggle={toggle} />;
}
